import styled from '@emotion/styled';


export const Root = styled.div(({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1.5)};
  margin-top: ${theme.spacing(2)};
`);
